"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.addParametersToAllLogs = exports.addToAllLogs = void 0;
const ContextUtils_1 = require("../ContextUtils");
const PARAMETERS_TO_LOG = new Map();
const getClassNameWithMethod = (target, propertyKey) => {
    return `${target.constructor.name}.${propertyKey.toString()}`;
};
function addToAllLogs(parameterName) {
    return function (target, propertyKey, parameterIndex) {
        const classNameWithMethod = getClassNameWithMethod(target, propertyKey);
        const parametersToLogPerMethod = PARAMETERS_TO_LOG.get(classNameWithMethod) || new Set();
        parametersToLogPerMethod.add({ name: parameterName, index: parameterIndex });
        PARAMETERS_TO_LOG.set(classNameWithMethod, parametersToLogPerMethod);
    };
}
exports.addToAllLogs = addToAllLogs;
function addParametersToAllLogs(target, methodName, descriptor) {
    const originalMethod = descriptor.value;
    descriptor.value = function (...args) {
        const classNameWithMethod = getClassNameWithMethod(target, methodName);
        const parametersToLog = PARAMETERS_TO_LOG.get(classNameWithMethod) || new Set();
        for (const paramIndex of parametersToLog) {
            const parameterValue = args[paramIndex.index];
            ContextUtils_1.contextUtils.addAdditionalLogAttribute(paramIndex.name, parameterValue);
        }
        return originalMethod.apply(this, args);
    };
}
exports.addParametersToAllLogs = addParametersToAllLogs;
//# sourceMappingURL=addToAllLogs.js.map